import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from 'app/app.component';
import { appConfig } from 'app/app.config';
import { register as registerSwiper } from 'swiper/element/bundle';

registerSwiper();
bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
